import { FC } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Breadcrumbs from 'components/Breadcrumbs';
import HotelImportsCard from 'components/HotelImportsCard';
import TripPricesCard from 'components/TripPricesCard';

const ToolsPage: FC = () => (
  <Box>
    <Breadcrumbs breadcrumbs={[{ name: 'Įrankiai' }]} />

    <Grid container spacing={2}>
      {/* <DiskCleanupCard /> */}
      <HotelImportsCard />
      <TripPricesCard />
    </Grid>
  </Box>
);

export default ToolsPage;
